var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row list-view"
  }, [_c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('header', {
    staticClass: "row p12 list-view-filter mb10",
    staticStyle: {
      "background": "var(--white)",
      "overflow": "visible"
    }
  }, [_c('div', {
    staticClass: "go-left"
  }, [_c('b', [_vm._v("Select Branch")]), _c('div', {
    staticClass: "row",
    staticStyle: {
      "min-width": "200px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.branchIds,
      expression: "search.branchIds"
    }],
    staticClass: "h40 mr6",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.search, "branchIds", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.searching]
    }
  }, _vm._l(_vm.branchs, function (brand, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": brand.id
      }
    }, [_vm._v(" " + _vm._s(brand.name) + " ")]);
  }), 0), false ? _c('multiselect', {
    attrs: {
      "options": _vm.branchs,
      "label": "name",
      "track-by": "id",
      "multiple": false,
      "taggable": true,
      "placeholder": "Search Branch",
      "open-direction": "bottom",
      "show-no-results": false,
      "internal-search": false,
      "clear-on-select": false,
      "close-on-select": true,
      "options-limit": 100
    },
    on: {
      "search-change": _vm.debouncedOnSearchBranchs,
      "input": _vm.onBranchSelected
    },
    model: {
      value: _vm.branchId,
      callback: function ($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  }) : _vm._e()], 1)])]), _c('header', {
    staticClass: "row p12 bg-white border-top-light-blue mb10 list-view-filter"
  }, [_c('div', {
    staticClass: "h-filter"
  }, [_c('div', {
    staticClass: "h-filter-item mt5"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Daterange")]), _c('date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "value-type": "format",
      "format": "YYYY-MM-DD",
      "range": "",
      "placeholder": "Select daterange"
    },
    model: {
      value: _vm.search.dateRange,
      callback: function ($$v) {
        _vm.$set(_vm.search, "dateRange", $$v);
      },
      expression: "search.dateRange"
    }
  })], 1), _c('div', {
    staticClass: "h-filter-item"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.invoiceNumber,
      expression: "search.invoiceNumber"
    }],
    staticClass: "h40",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Invoice number"
    },
    domProps: {
      "value": _vm.search.invoiceNumber
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searching.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.search, "invoiceNumber", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "h-filter-item"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.transactionNumber,
      expression: "search.transactionNumber"
    }],
    staticClass: "h40",
    attrs: {
      "type": "text",
      "placeholder": "Transaction number"
    },
    domProps: {
      "value": _vm.search.transactionNumber
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searching.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.search, "transactionNumber", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "h-filter-item"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.cardCode,
      expression: "search.cardCode"
    }],
    staticClass: "h40",
    attrs: {
      "type": "text",
      "placeholder": "Card Code"
    },
    domProps: {
      "value": _vm.search.cardCode
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searching.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.search, "cardCode", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "h-filter-item"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.accountId,
      expression: "search.accountId"
    }],
    staticClass: "h40",
    attrs: {
      "type": "text",
      "placeholder": "Account ID"
    },
    domProps: {
      "value": _vm.search.accountId
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searching.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.search, "accountId", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "h-filter-item"
  }, [_vm._m(4), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.customerGroupId,
      expression: "search.customerGroupId"
    }],
    staticClass: "h40 ph6",
    staticStyle: {
      "width": "fit-content",
      "max-width": "170px"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.search, "customerGroupId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    staticClass: "option-all",
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Customer Group")]), _vm._l(_vm.customerGroups, function (item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item === null || item === void 0 ? void 0 : item.id
      }
    }, [_vm._v(" " + _vm._s((item === null || item === void 0 ? void 0 : item.name) || 'N/A') + " ")]);
  })], 2)]), _c('div', {
    staticClass: "h-filter-item"
  }, [_vm._m(5), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.orderStatusId,
      expression: "search.orderStatusId"
    }],
    staticClass: "h40",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.search, "orderStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Status")]), _vm._l(_vm.data.orderStatus, function (orderStatus, orderStatusIndex) {
    return _c('option', {
      key: orderStatus.id,
      domProps: {
        "value": orderStatus.id
      }
    }, [_vm._v(" " + _vm._s(orderStatus.name) + " ")]);
  })], 2)]), _c('div', {
    staticClass: "h-filter-item"
  }, [_vm._m(6), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search.paymentStatus,
      expression: "search.paymentStatus"
    }],
    staticClass: "h40",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.search, "paymentStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Status")]), _c('option', {
    attrs: {
      "value": "success"
    }
  }, [_vm._v("Success")]), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Pending")]), _c('option', {
    attrs: {
      "value": "fail"
    }
  }, [_vm._v("Fail")])])]), _c('div', {
    staticClass: "h-filter-item",
    staticStyle: {
      "width": "fit-content",
      "min-width": "40px"
    }
  }, [_c('div', {
    staticClass: "filter-action filter-af"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm ah",
    on: {
      "click": _vm.searching
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _c('div', {
    staticClass: "row bg-white"
  }, [_c('header', {
    staticClass: "row p12"
  }, [_c('div', {
    staticClass: "go-left",
    staticStyle: {
      "display": "flex",
      "position": "relative",
      "align-items": "center",
      "gap": "30px"
    }
  }, [_c('b', [_vm._v("Orders")]), _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "position": "relative",
      "align-items": "center",
      "gap": "2px"
    }
  }, _vm._l(_vm.providers, function (i) {
    var _vm$search;
    return _c('span', {
      key: i.id,
      staticClass: "provier-item",
      class: {
        'provier-item-active': (i === null || i === void 0 ? void 0 : i.id) === ((_vm$search = _vm.search) === null || _vm$search === void 0 ? void 0 : _vm$search.provider)
      },
      on: {
        "click": function ($event) {
          return _vm.onSelectProvider(i === null || i === void 0 ? void 0 : i.id);
        }
      }
    }, [_vm._v(_vm._s(i === null || i === void 0 ? void 0 : i.name))]);
  }), 0)])]), _c('div', {
    staticClass: "table-control"
  }, [_c('table', {
    staticClass: "table wh800",
    attrs: {
      "cellspacing": "0"
    }
  }, [_vm._m(7), _vm.checkoutPermission('LIST_ORDER') ? _c('tbody', _vm._l(_vm.data.order, function (order, index) {
    var _vm$getProviderEnum, _vm$$provider, _vm$$helper$findColor, _vm$$masterCrm, _vm$$helper$findColor2, _vm$$masterCrm2, _order$orderStatus;
    return _c('tr', {
      key: (order, index),
      staticClass: "hover-list"
    }, [_c('td', [_vm._v(_vm._s(order === null || order === void 0 ? void 0 : order.id))]), _c('td', [_vm._v(_vm._s(order.invoiceNumber))]), _c('td', [_c('b', [_vm._v(_vm._s(order.transactionNumber))])]), _c('td', [_c('b', [_vm._v(_vm._s(order.account.code))])]), _c('td', [_vm._v(_vm._s(order.account.firstName) + " " + _vm._s(order.account.lastName))]), _c('td', {
      staticClass: "max-length"
    }, [_vm._v(_vm._s(order.remark || "N/A"))]), _c('td', [_vm._v(" " + _vm._s(((_vm$getProviderEnum = _vm.getProviderEnum((_vm$$provider = _vm.$provider) === null || _vm$$provider === void 0 ? void 0 : _vm$$provider.orderProviderEnum, order === null || order === void 0 ? void 0 : order.provider)) === null || _vm$getProviderEnum === void 0 ? void 0 : _vm$getProviderEnum.name) || "N/A") + " ")]), _c('td', {
      staticClass: "text-left"
    }, [_c('span', {
      style: {
        color: (_vm$$helper$findColor = _vm.$helper.findColor((_vm$$masterCrm = _vm.$masterCrm) === null || _vm$$masterCrm === void 0 ? void 0 : _vm$$masterCrm.CrmDeliveryStatus, order === null || order === void 0 ? void 0 : order.deliveryStatusId, ['id'])) === null || _vm$$helper$findColor === void 0 ? void 0 : _vm$$helper$findColor.textColor
      }
    }, [_vm._v(" " + _vm._s(((_vm$$helper$findColor2 = _vm.$helper.findColor((_vm$$masterCrm2 = _vm.$masterCrm) === null || _vm$$masterCrm2 === void 0 ? void 0 : _vm$$masterCrm2.CrmDeliveryStatus, order === null || order === void 0 ? void 0 : order.deliveryStatusId, ['id'])) === null || _vm$$helper$findColor2 === void 0 ? void 0 : _vm$$helper$findColor2.name) || 'N/A') + " ")])]), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s((order === null || order === void 0 ? void 0 : (_order$orderStatus = order.orderStatus) === null || _order$orderStatus === void 0 ? void 0 : _order$orderStatus.name) || "N/A"))]), _c('td', {
      staticClass: "txt-right"
    }, [_c('b', [_vm._v(_vm._s(_vm.$helper.formatPrice(order.totalAmount)))])]), _c('td', {
      staticClass: "text-center"
    }, [order.paymentMethod.name == 'CREDIT LINE' && order.paymentStatus == 'pending' ? _c('img', {
      attrs: {
        "src": require('@/assets/icons/pending-credit-line.jpg'),
        "height": "20px"
      }
    }) : _c('img', {
      attrs: {
        "src": order.paymentMethod.logoUrl ? _vm.getFullImage(order.paymentMethod.logoUrl) : require('@/assets/images/img-default.png'),
        "height": "20px"
      }
    })]), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(" " + _vm._s(order.paymentStatus) + " ")]), _c('td', [_vm._v(" " + _vm._s(order.createdAt && _vm.$helper.formatDate(order.createdAt)) + " ")]), _c('td', {
      staticStyle: {
        "text-align": "center",
        "position": "sticky",
        "right": "0",
        "z-index": "2",
        "background": "white"
      }
    }, [_vm.checkoutPermission('GET_ORDER_DETAIL') ? _c('button', {
      staticClass: "btn btn-info btn-xs",
      on: {
        "click": function ($event) {
          return _vm.viewOrder(order);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]) : _vm._e()])]);
  }), 0) : _vm._e()]), _vm.isFetching ? _c('TableLoading') : _vm._e(), _vm.isNoData && !_vm.isFetching ? _c('NoItem', {
    attrs: {
      "message": _vm.errorMessage
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "total ph12"
  }, [_c('div', {
    staticClass: "ul-xl-li go-left"
  }, [_vm._v("Total : " + _vm._s(_vm.data.pagination.total))]), _vm.data.pagination.totalPage > 0 ? _c('Pagination', {
    attrs: {
      "pagination": _vm.data.pagination.totalPage
    }
  }) : _vm._e()], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "m0"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Invoice")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "m0"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Transaction")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "m0"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Card Code")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "m0"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Account")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "m0"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Customer Group")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "m0"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Order Status")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "m0"
  }, [_c('b', {
    staticClass: "w100 font12"
  }, [_vm._v("Payment Status")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _c('th', [_vm._v("Inv. Num")]), _c('th', [_vm._v("Tran. Num")]), _c('th', [_vm._v("Card Code")]), _c('th', [_vm._v("Customer")]), _c('th', {
    staticClass: "w200"
  }, [_vm._v("Remark")]), _c('th', [_vm._v("Provider")]), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Delivery Status")]), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Order Status")]), _c('th', {
    staticClass: "txt-right"
  }, [_vm._v("Total")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Method")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Payment Status")]), _c('th', [_vm._v("Date Added")]), _c('th', {
    staticStyle: {
      "text-align": "center",
      "position": "sticky",
      "right": "0",
      "z-index": "2",
      "background": "white"
    }
  }, [_vm._v(" Action ")])])]);

}]

export { render, staticRenderFns }